import React from "react";
import { PropsWithChildren } from "react";

export const AppRouterPage = ({ children }: PropsWithChildren) => {
    return <>{children}</>;
};
